// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"3f040940","897":"3f040940"}[chunkId] + ".chunk.css";
};